<template>
  <div class="successed-box">
    <van-icon color="#3acd22" name="checked" size="80" />
    <p>恭喜您，设置成功！</p>
    <van-button class="loginBtn" type="primary" size="large" @click="go('login')">立即登录</van-button>
  </div>
</template>

<script>
import { Icon, Button } from "vant";

export default {
  data() {
    return {};
  },
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button
  },
  methods: {
    go(pathName) {
      this.$router.push({ name: pathName });
    }
  }
};
</script>

<style lang="less" scoped>
.successed-box {
  padding-top: 15px;
  text-align: center;
  p {
    font-size: 16px;
    margin-top:20px;
    color: #3acd22;
  }
  .loginBtn {
    margin-top: 25%;
  }
}
</style>
